import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { metaFor } from "@/seo/meta";

function setTag(selector, attr, key, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute(selector.startsWith("link") ? "href" : "content", value);
}

// Exported so a page (e.g. a blog post) can set its own title after loading.
export function applyMeta({ title, description, canonical, noindex }) {
  if (title) {
    document.title = title;
    setTag('meta[property="og:title"]', "property", "og:title", title);
    setTag('meta[name="twitter:title"]', "name", "twitter:title", title);
  }
  if (description) {
    setTag('meta[name="description"]', "name", "description", description);
    setTag('meta[property="og:description"]', "property", "og:description", description);
    setTag('meta[name="twitter:description"]', "name", "twitter:description", description);
  }
  if (canonical) {
    setTag('link[rel="canonical"]', "rel", "canonical", canonical);
    setTag('meta[property="og:url"]', "property", "og:url", canonical);
    setTag('meta[name="twitter:url"]', "name", "twitter:url", canonical);
  }
  if (noindex !== undefined) {
    setTag('meta[name="robots"]', "name", "robots", noindex ? "noindex, nofollow" : "index, follow");
  }
}

export default function Seo() {
  const { pathname } = useLocation();
  useEffect(() => {
    applyMeta(metaFor(pathname));
  }, [pathname]);
  return null;
}
